/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Auth_AdvancedInputs */

const cs_import_auth_advanced = /** @type {(inputs: Import_Auth_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokročilé: IT import token`)
};

const en_import_auth_advanced = /** @type {(inputs: Import_Auth_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advanced: IT import token`)
};

/**
* | output |
* | --- |
* | "Advanced: IT import token" |
*
* @param {Import_Auth_AdvancedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_auth_advanced = /** @type {((inputs?: Import_Auth_AdvancedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Auth_AdvancedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_auth_advanced(inputs)
	return cs_import_auth_advanced(inputs)
});